import { useQuery } from '@tanstack/react-query';
import { IMeetingEmailTemplate } from '../../Interfaces/IMeetingEmailTemplate';
import { customFetcher } from '../useFetch';

export const useGetMeetingEmailTemplates = () => {
  const {
    data: meetingEmailTemplates,
    isLoading: isLoadingMeetingEmailTemplates,
    refetch: refetchMeetingEmailTemplates,
  } = useQuery<IMeetingEmailTemplate[]>({
    refetchOnWindowFocus: false,
    queryKey: ['meetingemailtemplate'],
    queryFn: () => customFetcher({ endpoint: '/meetingemailtemplate' }),
  });

  return {
    meetingEmailTemplates,
    isLoadingMeetingEmailTemplates,
    refetchMeetingEmailTemplates,
  };
};
